import React from 'react';
import UserManagement from '../UserManagement';

// The project Settings screen's Workspace tab: the people in the workspace and their roles (one role per
// person covers every project). Project choices (currency, timezone, language, phone country) are in the
// Project tab; what is set once for the workspace (Billing, Vendor categories, WhatsApp) is on the account
// level Workspace Settings page. Archiving a project is in the Project tab.
const WorkspaceSettingsPanel: React.FC = () => (
  <div className="settings-section">
    <UserManagement />
  </div>
);

export default WorkspaceSettingsPanel;
